export const INDUSTRY_OPTIONS = [
  { value: 'software_saas',       label: 'Software / SaaS' },
  { value: 'property_management', label: 'Property Management' },
  { value: 'field_service',       label: 'Field Service (HVAC, Plumbing, Electrical, etc.)' },
  { value: 'healthcare',          label: 'Healthcare' },
  { value: 'retail_ecommerce',    label: 'Retail / E-Commerce' },
  { value: 'education',           label: 'Education' },
  { value: 'manufacturing',       label: 'Manufacturing' },
  { value: 'general',             label: 'General / Other' },
] as const;

export type IndustryValue = typeof INDUSTRY_OPTIONS[number]['value'];
